import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import NodeList from '@/components/common/Sidebar/NodeList.vue'
import NodeItem from '@/components/common/Sidebar/NodeItem.vue'
import { mapGetters, mapActions } from 'vuex';
import api from '@contact/api'

export interface MenuInfo {
    name: string
    id: string
    icon: string
    select: boolean
    expand: boolean
    child?: MenuInfo[]
    path: string,
    type: string,
    wellKnownFolderName?: string
}
@Component({
    components: { NodeList, NodeItem },
})


export default class ContactFolderList extends Vue {
    
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    menus: MenuInfo[] = [
        {
            name: this.$t('W_Contact_Favorites').toString(),
            id: '',
            icon: 'star',
            select: false,
            expand: true,
            child: [],
            path: 'contact-list',
            type: ''
        },
        {
            name: this.$t('W_Contact_PersonalAB').toString(),
            id: '',
            icon: 'folder',
            select: false,
            expand: true,
            child: [],
            path: 'contact-list',
            type: ''
        }
    ]

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    createdContactMenu() {
        this.getContactFavoriteFolder()
        this.getContactFolder()
    }

    getContactFavoriteFolder(parentId?: string) {
        let funcList = [
            api.favorite.getFavoriteFolderList(parentId),
            api.favorite.getPersonalFavoriteFolderList('MsgFolderRoot'),
            api.favorite.getPersonalFavoriteFolderList('Contacts'),
        ]

        Promise.all(funcList).then((resultArray) => {
            let items1 = resultArray[0]
            let items2 = resultArray[1] as ItemList<contacts.FolderItem>
            let items3 = resultArray[2] as ItemList<contacts.FolderItem>
            let lists = (items2 || []).concat(items3 || [])
            if (items1) {
                console.log('items1', items1)
                console.log('lists', lists)
                
                var favorite = this.menus.find(x => x.name == this.$t('W_Contact_Favorites').toString())?.child

                var folderItem: MenuInfo = {
                    name: this.$t('간편_주소록').toString(),
                    id: 'favorite',
                    icon:'star',
                    select: false,
                    expand: false,
                    path: 'contact-list',
                    type: 'router-link'
                }

                favorite?.push(folderItem)
            }

            if (lists) {
                var favorite = this.menus.find(x => x.name == this.$t('W_Contact_Favorites').toString())?.child
                lists.forEach((folder: any) => {
                    var folderItem: MenuInfo = {
                        name: '',
                        id: '',
                        icon:'',
                        select: false,
                        expand: false,
                        path: 'contact-list',
                        type: 'router-link'
                    }
                    folderItem.name = folder.displayName
                    folderItem.id = folder.id
                    folderItem.icon = 'folder'
            
                    favorite?.push(folderItem)
                })
            }
        })
    }

    getContactFolder(parentId?: string) {
        if (parentId) {
            return api.personal.getContactTree(parentId).then((res: ItemList<contacts.FolderItem>) => {

                console.log('res', res)
                const data = {
                    items: res,
                    parentId: parentId,
                }

                var personal = this.menus.find(x => x.name == this.$t('W_Contact_PersonalAB').toString())?.child

                data.items.forEach((folder: any) => {
                    var folderItem: MenuInfo = {
                        name: '',
                        id: '',
                        icon:'',
                        select: false,
                        expand: false,
                        path: 'contact-list',
                        type: 'router-link'
                    }
                    folderItem.name = folder.displayName
                    folderItem.id = folder.id
                    folderItem.icon = 'folder'
            
                    personal?.push(folderItem)
                })
            })
        } else {
            return new Promise((resolve, reject) => {
                Promise.all([api.personal.getBasicContactFolder(), api.personal.getContactTree(parentId)])
                  .then((res: ItemList<contacts.FolderItem>[]) => {

                    console.log('res', res)

                    const data = {
                      items: [...res[0], ...res[1]],
                      parentId: parentId,
                    }
                    var personal = this.menus.find(x => x.name == this.$t('W_Contact_PersonalAB').toString())?.child

                    data.items.forEach((folder: any) => {
                        var folderItem: MenuInfo = {
                            name: '',
                            id: '',
                            icon:'',
                            select: false,
                            expand: false,
                            path: 'contact-list',
                            type: 'router-link'
                        }
                        folderItem.name = folder.displayName
                        folderItem.id = folder.id
                        folderItem.icon = 'folder'
                
                        personal?.push(folderItem)
                    })
                    resolve(data.items)
                  })
                  .catch((err) => reject(err))
            })
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.createdContactMenu()
    }
}